<template>
  <div>
    <button
      @click="downloadFileExcel"
      type="button"
      class="subtitle-1 font-weight-medium valign-middle"
    >
      <icon-download
        :color="$vuetify.theme.primary"
        class="icon"
      ></icon-download>
      <span>
        Excel
      </span>
    </button>
    <button
      @click="downloadFileCSV"
      type="button"
      class="subtitle-1 font-weight-medium valign-middle ml-4"
    >
      <icon-download
        :color="$vuetify.theme.primary"
        class="icon"
      ></icon-download>
      <span>
        Csv
      </span>
    </button>
  </div>
</template>
<script>
import RequestApi from "../../modules/requestApi";
import IconDownload from "../icon/IconDownload.vue";

export default {
  name: "DownloadXlsxCsv",
  components: {
    IconDownload
  },
  props: {
    // параметры для выгрузки Excel/Csv
    param: {
      type: Object,
      required: true
    },
    // тип статистики
    type: {
      type: String
    }
  },
  methods: {
    /**
     * Скачивание файла excel c данными шаблона
     */
    downloadFileExcel() {
      RequestApi.downloadFileExcel({ param: this.param, type: this.type })
        .then(response => {
          window.location.href = response;
        })
        .catch();
    },
    /**
     * Скачивание файла csv c данными шаблона
     */
    downloadFileCSV() {
      RequestApi.downloadFileCSV({ param: this.param, type: this.type })
        .then(response => {
          window.location.href = response;
        })
        .catch();
    }
  }
};
</script>
